import { memo } from 'react';
import { IconWrapper } from './IconWrapper';

export const DeleteIcon = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                // eslint-disable-next-line max-len
                d="M6.257 19.5V5.89H5.25v-.695h3.728V4.5h6.044v.695h3.728v.696h-1.008V19.5H6.258Zm.706-.695h10.074V5.89H6.963v12.914Zm3.072-1.987h.706v-8.94h-.706v8.94Zm3.224 0h.706v-8.94h-.706v8.94Z"
            />
        </svg>
    </IconWrapper>
));
